(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trDeleteController',Module_trDeleteController);

    Module_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Module_tr'];

    function Module_trDeleteController($uibModalInstance, entity, Module_tr) {
        var vm = this;

        vm.module_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Module_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
